import { flatten, uniq } from 'lodash'
import { addPattern, getAllPatterns, getPatternDef } from './routerConfig'
import { getCollection } from './patternDef'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { RouterRef } from '@wix/editor-platform-sdk-types'
import type { PatternDefinition, RouterConfig } from './routerConfigTypes'

export const addOrUpdateRouterWithPattern = async (
  editorSdkProxy: EditorSDK,
  prefix: string,
  pattern: string,
  patternDef: PatternDefinition,
): Promise<RouterRef> => {
  let routerRef = await editorSdkProxy.routers.getByPrefix({ prefix })
  if (routerRef) {
    const { config } = await editorSdkProxy.routers.get<RouterConfig>({
      routerRef,
    })
    const updatedConfig = addPattern(config, pattern, patternDef)
    await editorSdkProxy.routers.update({
      routerRef,
      config: updatedConfig,
    })
  } else {
    routerRef = await editorSdkProxy.routers.add({
      prefix,
      config: addPattern({ patterns: {} }, pattern, patternDef),
    })
  }
  return routerRef
}

export const getExistingPatternsByPrefix = async (
  editorSdkProxy: EditorSDK,
  prefix: string,
): Promise<string[]> => {
  const routerRef = await editorSdkProxy.routers.getByPrefix({ prefix })
  if (routerRef) {
    const { config } = await editorSdkProxy.routers.get<RouterConfig>({
      routerRef,
    })

    return config ? getAllPatterns(config) : []
  }
  return []
}

export const getCollectionsBoundToRouter = async (
  editorSdkProxy: EditorSDK,
  routerRef: RouterRef,
): Promise<string[]> => {
  const { config } = await editorSdkProxy.routers.get<RouterConfig>({
    routerRef,
  })

  const routerPatterns = getAllPatterns(config)
  const collections = routerPatterns
    .map(pattern => getPatternDef(config, pattern))
    .map(getCollection)

  return uniq(flatten(collections))
}

export const routerConfigHasCollection = (
  config: RouterConfig,
  collectionId: string,
): boolean => {
  const patterns = getAllPatterns(config)

  return patterns.some((pattern: string) => {
    const patternDef = getPatternDef(config, pattern)
    return getCollection(patternDef) === collectionId
  })
}
